module.exports = __webpack_public_path__ + "img/excel.737ab605.png";